import type { SxProps, Theme } from '@mui/material';
import type { CSSProperties } from 'react';

const TOOLBAR_HEIGHT = 76;

export const styles = {
    background: {
        background: 'linear-gradient(180deg, #ECF0F5 41.56%, #FFFFFF 100%)',
        minWidth: '100vw',
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        flexDirection: 'column',
    } as SxProps<Theme>,
    appBar: { padding: '16px 24px' } as SxProps<Theme>,
    fullLogoImg: {
        maxWidth: '200px',
        height: 'auto',
        padding: '4px',
    } as CSSProperties,
    menu: {
        background: 'white',
        padding: '2% 7% 3%',
        marginTop: '2%',
        borderRadius: '16px',
        borderColor: '#ECF0F5',
        borderWidth: '1px',
    } as SxProps<Theme>,
    appShell: {
        marginTop: `${TOOLBAR_HEIGHT}px`,
        height: `calc(100vh - ${TOOLBAR_HEIGHT}px)`,
        overflow: 'hidden',
        boxSizing: 'border-box',
        py: { xs: 1.5, md: 3 },
        px: { xs: 1.5, md: 4 },
        position: 'relative',
    } as SxProps<Theme>,
    shellInner: {
        display: 'flex',
        flexDirection: 'row',
        height: '100%',
        gap: { xs: 0, md: 2 },
    } as SxProps<Theme>,
    drawerWrap: {
        flex: '0 0 200px',
        display: { xs: 'none', md: 'block' },
    } as SxProps<Theme>,
    drawerSpacer: {
        flex: '0 0 200px',
        display: { xs: 'none', md: 'block' },
    } as SxProps<Theme>,
    mobileDrawer: {
        display: { xs: 'block', md: 'none' },
        '& .MuiDrawer-paper': {
            width: 240,
            pt: 2,
            pl: 1,
            boxSizing: 'border-box',
        },
    } as SxProps<Theme>,
    outletWrap: {
        flex: 1,
        minWidth: 0,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
    } as SxProps<Theme>,
};
